import React from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Topic } from "../../../../Models/Topic";
import { TopicQuickMetrics } from "../../../../Models/TopicQuickMetrics";
import {
  LoadingState,
  ResponseError,
  ErrorDisplay,
  LoadingDisplay,
  ApiRequest,
  appPaths
} from "../../../../../Common";
import { ResponseResult } from "../../../../../Common/Models/ResponseResult";
import TopicSummaryGridItem from "./TopicSummaryGridItem";
import styles from "../../../../Styles/TopicSummaryGridItemContainer.module.scss";
import { endpoints } from "../../../../Constants/endpoints";
import ResponseHandler from "../../../../../App/ResponseHandler";
import TopicIcon from "../../TopicIcon/TopicIcon";

type Props = {
  topic: Topic;
  metrics: TopicQuickMetrics;
  loadingState: LoadingState;
};

export default class TopicSummaryGridItemContainer extends React.Component<Props> {
  render() {
    const topicLink = appPaths.topic.featureRequests.replace(":topicCode", this.props.topic.code);
    return (
      <Link
        to={topicLink}
        className={styles.topicSummaryGridItemContainer}
        title={`Click here to view the Feedback submitted for the "${this.props.topic.name}" topic`}
      >
        <Row>
          <Col sm={3}>
            <TopicIcon topicCode={this.props.topic.code} className={styles.topicIcon} />
          </Col>
          <Col sm={9} className={styles.topicNameCol}>
            <h4>{this.props.topic.name}</h4>
          </Col>
        </Row>
        {this.props.loadingState.isLoading && <LoadingDisplay />}
        {this.props.loadingState.isLoaded && <TopicSummaryGridItem metrics={this.props.metrics} />}
      </Link>
    );
  }
}
